import { Pivot, PivotItem, PivotLinkSize } from '@fluentui/react';
import React, { useMemo } from 'react';
import { BwjPageContent } from '../../../../framework/components/bwj-page-content';
import { AppRoutes, getAppRouteByKey, getAppRouteByPathname, toProjectSlug } from '../../../app-routes';
import { ProjectOverviewService } from '../../services/project-overview';
import { useNavigator } from '../../../../framework/services/navigation';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import { IAdminAppRoute } from '../../../admin-app-route';
import { toKebabCase, toTitleText } from '../../../../framework/utils/string';
import { DoorType } from '../../../../entities-generated/common/door-type';

export const PageProjectOverviewInstallationSite: React.FunctionComponent = () => {
  const nav = useNavigator();
  const location = useLocation();
  const { projectId, site, doorType } = useMemo(() => {
    const route = getAppRouteByPathname(location.pathname);
    if(!route || !route.regex) { return { projectId: '', site: '', doorType: '' }; }
    const match = location.pathname.match(route.regex)!;
    return { projectId: `${match[1].substring(0, 4)}.${match[1].substring(4)}`, site: match[2], doorType: match[3] };
  }, [location]);
  const selectedKey = useMemo(() => {
    const route = getAppRouteByPathname(location.pathname);
    if(!route) { return ''; }
    if(route.key === AppRoutes.projectOverviewInstallSiteDoor.key) {
      return `${route.key}-${doorType}`;
    }
    return route.key;
  }, [location, doorType]);
  const installSite = ProjectOverviewService.getInstallationSite(site!);
  if(!installSite) {
    nav.goTo(AppRoutes.projectOverview.url(toProjectSlug(projectId)));
  }

  const onTabClick = (tab?: PivotItem) => {
    if(!tab || !tab.props.itemKey) { return; }
    const key = tab.props.itemKey;
    if(key === selectedKey) { return; }

    const doorRoute = AppRoutes.projectOverviewInstallSiteDoor;
    if(key.startsWith(doorRoute.key)) {
      const slug = key.substring(doorRoute.key.length + 1);
      nav.goTo(doorRoute.url(toProjectSlug(projectId), site!, slug));
    } else {
      const route = getAppRouteByKey(key) as IAdminAppRoute<(id: string, site: string) => string>;
      nav.goTo(route.url(toProjectSlug(projectId), site!));
    }
  }

  return (
    <BwjPageContent contentDescription={'tab menu and subcontent'}>
      <Pivot
        aria-label='Export Record Data View Modes'
        linkSize={'large'}
        headersOnly={true}
        onLinkClick={onTabClick}
        selectedKey={selectedKey}
      >
        <PivotItem
          headerText={AppRoutes.projectOverviewInstallSitePhotos.sideMenuLabel}
          itemKey={AppRoutes.projectOverviewInstallSitePhotos.key}
          itemIcon={AppRoutes.projectOverviewInstallSitePhotos.icon}
        />
        {installSite!.doorInstallations.map(doorInstall =>
        <PivotItem
          key={`${AppRoutes.projectOverviewInstallSiteDoor.key}-${toKebabCase(DoorType[doorInstall.doorType])}`}
          headerText={toTitleText(DoorType[doorInstall.doorType])}
          itemKey={`${AppRoutes.projectOverviewInstallSiteDoor.key}-${toKebabCase(DoorType[doorInstall.doorType])}`}
          itemIcon={AppRoutes.projectOverviewInstallSiteDoor.icon}
        />
        )}
      </Pivot>
      <Switch>
        <Route path={AppRoutes.projectOverviewInstallSite.urlTemplate} exact>
          <Redirect to={AppRoutes.projectOverviewInstallSitePhotos.url(toProjectSlug(projectId), site!)} />
        </Route>
        <Route
          path={AppRoutes.projectOverviewInstallSitePhotos.urlTemplate}
          exact={AppRoutes.projectOverviewInstallSitePhotos.exact}
          component={AppRoutes.projectOverviewInstallSitePhotos.component}
        />
        <Route
          path={AppRoutes.projectOverviewInstallSiteDoor.urlTemplate}
          exact={AppRoutes.projectOverviewInstallSiteDoor.exact}
          component={AppRoutes.projectOverviewInstallSiteDoor.component}
        />
      </Switch>
    </BwjPageContent>
  );
};
